<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'MedicationAdministration',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>